export const parseFragment = (fragment) => {
  console.log(fragment);

  return JSON.parse(fragment);
};
